class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp);
    this.addEventListener("click", this.click);
    this.mainDetailsToggle.addEventListener(
      "focusout",
      (event) => {
        if (event.relatedTarget !== null) {
          this.onFocusOut(event);
        }
      }
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector("summary");

    openDetailsElement.removeAttribute("open");
    summaryElement.focus();
  }

  click(event) {
    const header = document.getElementById("shopify-section-header");
    const openDetailsElement = event.target.closest("details[open]");
    const element = event.target;
    if (!openDetailsElement) {
      header.classList.add("shopify-section-header-sticky");
      header.classList.add("shopify-section-header-opaque");
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  close() {
    const header = document.getElementById("shopify-section-header");
    this.mainDetailsToggle.removeAttribute("open");
    header.classList.remove("shopify-section-header-opaque");
  }
}

customElements.define("details-disclosure", DetailsDisclosure);
